import { Text, Transformer } from 'react-konva';
import { Fragment, useRef, useEffect, useState } from 'react';

const EditableText = ({index, onSelect, x, y, text, fontSize, fontFamily, fontStyle, 
                    textDecoration, isSelected, rotation, onTextBoxChange, addTextArea, textColor, width, textAlignment}) => {

    const editableTextRef = useRef();
    const transformerRef = useRef();

    const MIN_WIDTH = 20;

    useEffect(() => {
        if (isSelected) {
          // we need to attach transformer manually
          transformerRef.current.nodes([editableTextRef.current]);
          transformerRef.current.getLayer().batchDraw();
        }
      }, [isSelected]);

    return (
        <Fragment>
            <Text
                key={ index }
                ref={editableTextRef}
                onClick={ onSelect }
                onTap={ onSelect }
                text = {text}
                align = {textAlignment}
                keepRatio={true}
                width={width}
                rotation = {rotation}
                fontSize = {fontSize}
                fontStyle = {fontStyle}
                fontFamily = {fontFamily}
                textDecoration={textDecoration}
                fill={textColor}
                draggable={true}

                onDblClick={() => {
                    let node = editableTextRef.current;
                    let tr = transformerRef.current;
                    const scaleX = node.scaleX();

                    const textPosition = node.absolutePosition();

                    // node.scaleX(1);
                    // node.scaleY(1);
                    let areaPosition = {
                        x: textPosition.x,
                        y: textPosition.y,
                        width: node.width() * scaleX,
                        height: node.height() * node.scaleY(),
                        // width: node.width(),
                        // height: node.height(),
                        textAlignment: node.align(),
                        fontSize: node.fontSize(),
                        textColor: node.fill(),
                        lineHeight: node.lineHeight()
                    }

                    addTextArea(areaPosition);
                    // tr.hide()
                }}

                x={x}
                y={y}

                onTransform = {(e) => {
                    const node = editableTextRef.current;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();

                    // we will reset it back
                    // node.scaleX(1);
                    // node.scaleY(1);
                    console.log(node.width() * scaleX)
                    onTextBoxChange(index, {
                        x: node.x(),
                        y: node.y(),
                        width: node.width() * node.scaleX(),
                        height: node.height() * node.scaleY(),
                        textAlignment: node.align(),
                        // width: node.width(),
                        // height: node.height(),
                        fontSize: node.fontSize(),
                        rotation: node.rotation()
                    });
                }}
                onDragEnd = {(e) => {
                    const node = editableTextRef.current;
                    // const scaleX = node.scaleX();
                    // we will reset it back

                    // node.scaleX(1);
                    // node.scaleY(1);
                    console.log("Offsets: "+ text, node.offsetX(), node.offsetY());
                    onTextBoxChange(index, {
                        x: node.x(),
                        y: node.y(),
                        width: node.width(),
                        height: node.height(),
                        textAlignment: node.align(),
                        // width: node.width(),
                        // height: node.height(),
                        fontSize: node.fontSize(),
                        rotation: node.rotation()
                    });
                }
                }
            />
            {   isSelected && (
                <Transformer
                        ref={transformerRef}
                        enabledAnchors={['middle-right']}
                        // enabledAnchors={[]}
                        rotateEnabled={false}
                        borderStroke={"teal"}
                        anchorStroke={"teal"}
                        centredScaling={true}
                        keepRatio={true}
                        boundBoxFunc={(oldBox, newBox) => {
                            // limit resize
                            if (newBox.width < 50 || newBox.height < 5) {
                              return oldBox;
                            }
                            return newBox;
                        }}
                        // boundBoxFunc={(oldBox, newBox) => {
                        //     if (newBox.width < MIN_WIDTH) {
                        //       return oldBox;
                        //     }
                        //     return newBox;
                        // }}
                />
            )
            }
        </Fragment>
    )
}

export default EditableText;